import { useEffect, useLayoutEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { fetchHeaderContentDocumentWithFallback } from '../lib/api/headerContentApi';
import {
  applyHeaderDataToWindowAndTheme,
  getDefaultHeaderAreaData,
  mergeHeaderDocumentToHeaderData,
} from '../../sites/default/pages/system/HeaderAreaManager';

/**
 * 헤더 영역 관리(DB) 배지·로고 JSON → window.headerContent · themeConfig.headerLogo 반영
 */
export default function useHeaderContent() {
  const themeContext = useTheme();
  const themeConfig = themeContext?.themeConfig || {};
  const setTheme = themeContext?.set;

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    if (!window.headerContent?.headerData) {
      applyHeaderDataToWindowAndTheme(getDefaultHeaderAreaData(), setTheme);
    }
  }, [setTheme]);

  useEffect(() => {
    const wid =
      Number(themeConfig.workspaceId || (typeof window !== 'undefined' && window.__themeConfig?.workspaceId)) || 1;
    let cancelled = false;

    (async () => {
      try {
        const doc = await fetchHeaderContentDocumentWithFallback(wid);
        if (cancelled) return;
        const merged = mergeHeaderDocumentToHeaderData(doc);
        applyHeaderDataToWindowAndTheme(merged, setTheme);
      } catch {
        if (!cancelled) {
          applyHeaderDataToWindowAndTheme(getDefaultHeaderAreaData(), setTheme);
        }
      }
    })();

    const onHeaderConfigSaved = async (ev) => {
      if (ev.detail?.workplaceId != null && ev.detail.workplaceId !== wid) return;
      try {
        const doc = await fetchHeaderContentDocumentWithFallback(wid);
        const merged = mergeHeaderDocumentToHeaderData(doc);
        applyHeaderDataToWindowAndTheme(merged, setTheme);
      } catch (e) {
        console.warn('[useHeaderContent] glow-header-config-saved 재병합 생략:', e?.message);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('glow-header-config-saved', onHeaderConfigSaved);
    }
    return () => {
      cancelled = true;
      if (typeof window !== 'undefined') {
        window.removeEventListener('glow-header-config-saved', onHeaderConfigSaved);
      }
    };
  }, [themeConfig.workspaceId, setTheme]);
}
